import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const OptionItemSquareListStyles = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 16px;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

export const OptionItemSquareStyles = styled.div<{
  isSelected: boolean;
  bgSrc: string;
}>`
  --bg-color: #ffffff80;
  --bg-color-selected: #ece4fd;
  box-sizing: border-box;
  aspect-ratio: 0.83;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  cursor: pointer;
  padding: 12px;
  border-radius: 16px;
  position: relative;
  font-size: 0;
  line-height: 0;

  ${({ isSelected }) =>
    isSelected &&
    `
      &::before {
        content: '';
        position: absolute;
        top: -4px;
        left: -4px;
        right: -4px;
        bottom: -4px;
        border-radius: 12px;
        background: linear-gradient(95.02deg, #D9002F 0%, #7F001C 100%);
        z-index: 0;
      }
    `}

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    font-size: 0;
    line-height: 0;
    filter: ${({ isSelected }) => (isSelected ? 'none' : 'grayscale(1)')};
    opacity: ${({ isSelected }) => (isSelected ? '1' : '0.8')};
  }

  & > .shadow-mask {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% + 1px);
    height: calc(100% + 1px);
    z-index: 2;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, #000 100%);
    box-sizing: border-box;
    border-radius: 12px;
    font-size: 0;
    line-height: 0;
  }
`;

export const OptionItemSquareTitleStyles = styled(UiTypography)`
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  z-index: 3;
  margin: 0;
  text-align: center;
`;
